import React from 'react'
import styles from './styles.css'
import {withRouter, Link} from 'react-router'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'

const links = [
  {title: 'Usuarios', path: '/admin', prop: 'users'},
  {
    title: 'Organizaciones',
    path: '/admin/organizationsdata',
    prop: 'organizations'
  },
  // {title: 'Codigo Descuento', path: '/admin/codediscount'},
]

@withGraphQL(
  gql`
    query usersData {
      usersData
    }
  `,
  {
    //  options: {pollInterval: 1000}
  }
)
@withRouter
export default class Layout extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    children: PropTypes.node,
    usersData: PropTypes.object
  }

  renderLinks() {
    return links.map((link, index) => {
      const isActive = this.props.router.location.pathname === link.path
      return (
        <div key={index} onClick={link.onClick} className={isActive ? 'active' : ''}>
          <Link to={link.path}>
            ({this.props.usersData[link.prop]}) {link.title}
          </Link>
        </div>
      )
    })
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="tabs">{this.renderLinks()}</div>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/Layout/index.js